import { defineMessages } from 'react-intl';

export const workingHoursMessages = defineMessages({
    editWorkingHours: {
        id: 'edit-working-hours',
        defaultMessage: 'Edit working hours',
    },
    addWorkingHours: {
        id: 'add-working-hours',
        defaultMessage: 'Add working hours',
    },
    addWorkingHoursSubtitle: {
        id: 'add-working-hours-subtitle',
        defaultMessage: 'Add new working hours',
    },
    editWorkingHoursSubtitle: {
        id: 'edit-working-hours-subtitle',
        defaultMessage: 'Edit working hours',
    },
    deleteWorkingHoursSubtitle: {
        id: 'delete-working-hours-subtitle',
        defaultMessage: 'Permanently delete working hours',
    },
    confirmDeleteWorkingHours: {
        id: 'confirm-delete-working-hours',
        defaultMessage: 'Are you sure you want to delete the working hours? This action cannot be undone.',
    },
    workingHours: {
        id: 'working-hour',
        defaultMessage: 'Working hours',
    },
    createWorkingHoursSuccess: {
        id: 'create-working-hours-success',
        defaultMessage: 'Working hours created',
    },
    updateWorkingHoursSuccess: {
        id: 'update-working-hours-success',
        defaultMessage: 'Working hours updated',
    },
    deleteWorkingHoursSuccess: {
        id: 'delete-working-hours-success',
        defaultMessage: 'Working hours deleted',
    },
    createWorkingHoursSuccessDescription: {
        id: 'create-working-hours-success-description',
        defaultMessage: 'Working hours has been successfully created.',
    },
    updateWorkingHoursSuccessDescription: {
        id: 'update-working-hours-success-description',
        defaultMessage: 'Working hours has been successfully updated.',
    },
    deleteWorkingHoursSuccessDescription: {
        id: 'delete-working-hours-success-description',
        defaultMessage: 'Working hours has been successfully deleted.',
    },
    openWorkingHoursDashboard: {
        id: 'open-working-hours-dashboard',
        defaultMessage: 'Open working hours dashboard',
    },
    zone: {
        id: 'zone',
        defaultMessage: 'Zone',
    },
    weekday: {
        id: 'weekday',
        defaultMessage: 'Weekday',
    },
    allDay: {
        id: 'all-day',
        defaultMessage: 'All day',
    },
    startTime: {
        id: 'start-time',
        defaultMessage: 'Start time',
    },
    endTime: {
        id: 'end-time',
        defaultMessage: 'End time',
    },
    monday: {
        id: 'monday',
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: 'tuesday',
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: 'wednesday',
        defaultMessage: 'Wednesday',
    },
    thursday: {
        id: 'thursday',
        defaultMessage: 'Thursday',
    },
    friday: {
        id: 'friday',
        defaultMessage: 'Friday',
    },
    saturday: {
        id: 'saturday',
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: 'sunday',
        defaultMessage: 'Sunday',
    },
    timeFrame: {
        id: 'time-frame',
        defaultMessage: 'Time frame',
    },
    backToAllSites: {
        id: 'back-to-all-sites',
        defaultMessage: 'Back to all sites',
    },
    workingHoursExceptions: {
        id: 'working-hour-exceptions',
        defaultMessage: 'Working hours exceptions',
    },
    date: {
        id: 'date',
        defaultMessage: 'Date',
    },
    isOpen: {
        id: 'is-open',
        defaultMessage: 'Is open',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    workingHoursException: {
        id: 'working-hour-exception',
        defaultMessage: 'Working hours exception',
    },
});